<template>
    <div class="rounded-20 bg-white pd-x-30 pd-y-20">
        <div class="tx-semibold tx-12">{{ title }}</div>
        <div v-if="userInfo.rdy" class="flex flex-col sm:flex-row mg-t-10 wd-auto" >
            <div :class="`${buddyObj.rdy?'':'wd-50p'}  pd-r-20 d-flex`">
                <div class="wd-40p">
                    <!-- <img :src="`${$store.state.user.userInfo.avator}`" class="wd-100p rounded-20"> -->
                    <img :src="`${userInfo.obj.defaultAttachmentUrl}`" class="wd-100p rounded-20 shadow">
                </div>
                <div class="wd-60p pd-l-10">
                    <div class="mg-b-20">
                    <div class="text-muted">Нэр:</div>
                    <div class="tx-semibold tx-12">{{ userInfo.obj.user.fullName }}</div>
                    </div>
                    <div class="mg-b-20">
                    <div class="text-muted">Нэгж:</div>
                    <div class="tx-semibold tx-12">{{ userInfo.obj.departName }}</div>
                    </div>
                    <div class="mg-b-20">
                    <div class="text-muted">Албан тушаал:</div>
                    <div class="tx-semibold tx-12">{{ userInfo.obj.position }}</div>
                    </div>
                </div>
            </div>
            <div :class="`${buddyObj.rdy?'pd-x-20':'wd-50p pd-l-20'}  bd-l`">
                <div class="mg-b-20">
                    <div class="text-muted">Дотуур утас:</div>
                    <div class="tx-semibold tx-12">{{ userInfo.obj.prefix }}</div>
                </div>
                <div class="mg-b-20">
                    <div class="text-muted">И-мэйл хаяг:</div>
                    <div class="tx-semibold tx-12">{{ userInfo.obj.user.email }}</div>
                </div>
                <!-- <div class="mg-b-20">
                    <div class="text-muted">Skype</div>
                    <div class="tx-semibold tx-12">Энд дарна уу</div>
                </div> -->
            </div>
            <div v-if="buddyObj.rdy" :class="`${buddyObj.rdy?'':'wd-50p'} pd-l-20  bd-l`">
                <div class="mg-b-20">
                    <div class="text-muted">Buddy ажилтан болсон огноо</div>
                    <div class="tx-semibold tx-12">{{ userInfo.obj.d3 | moment('YYYY.MM.DD') }}</div>
                </div>
                <div class="mg-b-20">
                    <div class="text-muted">Ажилд орсон огноо</div>
                    <div class="tx-semibold tx-12">{{ userInfo.obj.dueStartDate | moment('YYYY.MM.DD') }}</div>
                </div>
                <div class="mg-b-20">
                    <div class="text-muted">Buddy ажилтнаар ажилласан өдөр</div>
                    <div class="tx-semibold tx-12">{{ getBuddiedDate(userInfo.obj) }}</div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            <div class="d-flex align-items-center">
                Үнэлэх 
                <Rate v-model="rateValue" @change="rateChange" :disabled="!rateTaskId" class="mg-l-10"></Rate>
            </div>
        </div>
        </div>
</template>
<script>
import { request } from "@/api/all";
const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Rate, Notification } from "element-ui";

export default {
    components: {
        Rate
    },
    props:{
        title: {
            type: String,
            default: () => ""
        },
        userTaskId: {
            type: Number,
            default: () => null,
        },
        rateTaskId: {
            type: Number,
            default: () => null,
        },
        buddyObj: {
            type: Object,
            default: () => ({
                rdy: false,
                obj:{}
            }),
        },
    },
    data(){
        return {
            rateValueReal: 0,
            rateValue: 0,
            userInfo:{
                obj: {},
                rdy: false
            }
        }
    },
    mounted(){
        if(this.userTaskId!=null && this.userTaskId>0){
            this.initProfile(this.userTaskId);
        }
        if(this.rateTaskId!=null && this.rateTaskId>0){
            this.initRate(this.rateTaskId);
        }
    },
    methods:{
        rateChange(value){
            // console.log('rateChange', )
            if(this.rateValueReal>0){
                Notification.error("Үнэлгээ оруулсан байна.");
                this.rateValue= this.rateValueReal;
                return;
            }

            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
                api: { method: "POST", url: "task/SetTaskFieldValue" },
                data: { 
                    id: this.rateTaskId,
                    fieldName: "i7",
                    value: value
                },
                store: this.$store,
            }).then((res) => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                    Notification.success("Амжилттай. Үнэлгээ орууллаа.");
                    this.rateValueReal= value;
                    //this.rateValue= res.data.value;                    
                }
            });
        },
        initRate(rateTaskId){
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
                api: { method: "POST", url: "task/GetTaskFieldValue" },
                data: { 
                    id: this.rateTaskId,
                    fieldName: "i7"
                },
                store: this.$store,
            }).then((res) => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                    this.rateValueReal= res.data.value;
                    this.rateValue= res.data.value;
                }
            });
        },
        getBuddiedDate(obj){
            let rv;
            const start = moment(obj.d3).startOf('day');
            const end = moment(obj.d4).startOf('day');
            const now = moment().startOf('day');
            if(obj.d4!=null){
                if(moment(obj.d4).isAfter(now)){
                    rv= now.diff(start, 'days');
                }else{
                    rv= end.diff(start, 'days');
                }
            }else{
                rv= now.diff(start, 'days');
            }
            return rv;
        },
        initProfile(userTaskId){
            this.userInfo.rdy= false;
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
                api: { method: "GET", url: "task/info" },
                params: { id: this.userTaskId },
                store: this.$store,
            }).then((res) => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                this.userInfo.obj= res.data.task;
                this.userInfo.rdy= true;
                this.$emit('on-user-info', res.data.task.user);
                }
            });
        },
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === "addClass") {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },
    }
}
</script>